









































import { Component, Vue, Prop, PropSync } from 'vue-property-decorator';
import debounce from 'lodash.debounce';
import { NodesApi, Node } from '@/api';
import { Validation } from 'vuelidate';
import { VueSelect } from 'vue-select';

@Component({
	components: { VueSelect },
})
export default class NodeSuggest extends Vue {
	// computed
	get validationState() {
		if (this.validator) {
			return this.validator.$dirty && this.validator.$invalid;
		}
		return null;
	}

	@PropSync('node') public localNode!: Node;

	@Prop(Object)
	public readonly validator?: Validation;

	@Prop(Boolean)
	public readonly disabled?: boolean;

	@Prop(Boolean)
	public readonly state?: boolean;

	@Prop(Number)
	public transceiverId?: number;

	@Prop(Array)
	public type: string[] | [] | undefined;

	public options: Node[] = [];
	private api: NodesApi;

	constructor() {
		super();
		this.api = new NodesApi();
		this.debouncedOptions = debounce(this.fetchOptions, 100);
	}

	public onSelect(item: any) {
		if (this.validator) {
			this.validator.$touch();
		}

		this.localNode = item;
		this.$emit('input', item);
	}

	public onSearch(search: string) {
		this.debouncedOptions.cancel();
		this.debouncedOptions(search);
	}

	public async fetchOptions(search: string) {
		// get orgs
		const options = {
			params: {
				include: 'transceiver.site',
				'filter[serialNumber]': search,
				'fields[gateways]': 'id,serialNumber',
				'filter[transceiverId]': this.transceiverId,
			},
		};
		const response = await this.api.getNodes(options);
		this.options = response.data.data || [];
	}

	private readonly debouncedOptions: any = () => {
		return [];
	};
}
